import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [
    { path: '/', label: t('Home', 'Inicio') },
    { path: '/investors', label: t('Investors', 'Inversores') },
    { path: '/grants', label: t('Grants', 'Subvenciones') },
    { path: '/partners', label: t('Partners', 'Socios') },
    { path: '/warcliv', label: 'Warcliv' },
    { path: '/contact', label: t('Contact', 'Contacto') },
  ];

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_metasigna-biotech/artifacts/qm1lcp7g_1MFqTR3qcW31JHxa0wolu.png" 
              alt="Metasigna - Oncología Metabólica de Nueva Generación"
              className="h-14 md:h-16 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors hover:text-[#2E5090] ${
                  location.pathname === link.path
                    ? 'text-[#1F4E78] border-b-2 border-[#FFD700] pb-1'
                    : 'text-gray-700'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Language Toggle */}
          <div className="flex items-center space-x-4">
            <button
              onClick={toggleLanguage}
              className="flex items-center space-x-2 px-3 py-1.5 rounded-full bg-gray-100 hover:bg-gray-200 border border-gray-300 transition-all duration-200 hover:shadow-md"
            >
              {language === 'en' ? (
                <>
                  <span className="text-lg">🇪🇸</span>
                  <span className="text-sm font-semibold text-gray-700">ES</span>
                </>
              ) : (
                <>
                  <span className="text-lg">🇺🇸</span>
                  <span className="text-sm font-semibold text-gray-700">EN</span>
                </>
              )}
            </button>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden p-2 rounded-md text-gray-700 hover:bg-gray-100"
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setMobileMenuOpen(false)}
                className={`block py-2 px-4 text-sm font-medium transition-colors hover:bg-gray-50 ${
                  location.pathname === link.path
                    ? 'text-[#1F4E78] bg-gray-50'
                    : 'text-gray-700'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
